var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.78125 4H9.86875C10.1448 4 10.3687 3.7761 10.3687 3.5C10.3687 3.2239 10.1448 3 9.86875 3H8.78125C7.61645 3 6.66875 3.9477 6.66875 5.1125V6H5.96875C5.69265 6 5.46875 6.2239 5.46875 6.5C5.46875 6.7761 5.69265 7 5.96875 7H6.66875V11.2C6.66875 11.4761 6.89265 11.7 7.16875 11.7C7.44485 11.7 7.66875 11.4761 7.66875 11.2V7H9.66875C9.94485 7 10.1687 6.7761 10.1687 6.5C10.1687 6.2239 9.94485 6 9.66875 6H7.66875V5.1125C7.66875 4.4991 8.16785 4 8.78125 4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66797 12H3.66797C2.01377 12 0.667969 10.6542 0.667969 9V3C0.667969 1.3458 2.01377 0 3.66797 0H9.66797C11.3222 0 12.668 1.3458 12.668 3V9C12.668 10.6542 11.3222 12 9.66797 12ZM3.66797 1C2.56517 1 1.66797 1.8972 1.66797 3V9C1.66797 10.1028 2.56517 11 3.66797 11H9.66797C10.7708 11 11.668 10.1028 11.668 9V3C11.668 1.8972 10.7708 1 9.66797 1H3.66797Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.d5957c072169a986510935a46de9768a.svg";
export { ForwardRef as ReactComponent };